// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-error .quill-editor > * {\n  border-color: #ff4949;\n}\n", ""]);
// Exports
module.exports = exports;
